<template>
  <v-card>
    <v-card-title v-if="(selected ? selected.length : 0) <= max">
      <h2 class="dialog-card__header">Select no more than
        {{max - (selected ? selected.length : 0)}} communities
      </h2>
    </v-card-title>
    <v-card-title v-else>
      <h2 class="dialog-card__header">
       Invalid selection. Selected too many elements.
      </h2>
    </v-card-title>
    <v-form>
      <v-card-text>
        <div class="search">
          <v-text-field v-model="search" prepend-icon="search" label="Search"
                        single-line hide-details></v-text-field>
        </div>
        <div v-if="communities" class="list">
          <v-data-table
            :headers="headers"
            v-model="selected"
            :items="communities"
            :search="search"
            show-select
            :items-per-page="10"
            :custom-sort="customSort"
            hide-default-footer
            hide-default-header
            >
            <template v-slot:item.pro="{ item }">
              <v-chip v-if="item.key.namespace === 'pro'"
                      class="community__label" color="primary" dark>
                pro
              </v-chip>
            </template>
          </v-data-table>
        </div>
        <v-card-actions>
          <v-btn :disabled="!validSelection" class="custom-btn"
                 color="secondary" @click="confirm()">
            Confirm ➞
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import {keyToQuery, keyToQuery_, parens, names} from "../../_utils/communityNames"

  export default {
      props: ["max", "value"],
      data: () => ({
          selected: [],
          search: "",
          headers: [
              {
                  align: 'left',
                  text: 'Name',
                  value: 'key.name'
              }, {
                  align: 'left',
                  text: 'Pro',
                  value: 'pro'
              },
          ]
      }),
      computed: {
        ...mapState({communities: "communities"}),
        validSelection() {
          if (! this.selected) {
            return false
          }
          return this.selected.length > 0 && this.selected.length <= this.max
        }
      },
      mounted () {
          this.selected = this.value
      },
      methods: {
          confirm () {
              this.$emit("input", this.selected)
          },
          customSort(items, index, isDesc) {
            // Motivation: checked items go always to top
            // https://stackoverflow.com/questions/52678905/how-to-use-vutifys-custom-sort
            items.sort((a, b) => {
              if (this.selected && this.selected.indexOf(a) >= 0) {
                 if (this.selected.indexOf(b) >= 0) {
                   return a.key.name < b.key.name ? -1 : 1;
                 }
                 else {
                   return -1;
                 }
              }

              if (this.selected && this.selected.indexOf(b) >= 0) {
                return 1;
              }

              if (!isDesc[0]) {
                return a.key.name < b.key.name ? -1 : 1;
              } else {
                return b.key.name < a.key.name ? -1 : 1;
              }
            });
            return items;
          }

      },
      watch: {
          value: {
              handler (val) {
                  this.selected = val
              },
              deep: true
          }
      }
  }
</script>
